import { render, staticRenderFns } from "./TipoMedidaForm.vue?vue&type=template&id=0490b1f7&scoped=true&"
import script from "./TipoMedidaForm.vue?vue&type=script&lang=ts&"
export * from "./TipoMedidaForm.vue?vue&type=script&lang=ts&"
import style0 from "./TipoMedidaForm.vue?vue&type=style&index=0&id=0490b1f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0490b1f7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0490b1f7', component.options)
    } else {
      api.reload('0490b1f7', component.options)
    }
    module.hot.accept("./TipoMedidaForm.vue?vue&type=template&id=0490b1f7&scoped=true&", function () {
      api.rerender('0490b1f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TipoMedida/TipoMedidaForm.vue"
export default component.exports